<template>
  <a-form 
    class="ant-advanced-search-form" 
    :label-col="{span: 4, offset: 1}"
    :wrapperCol ="{span: 18, offset: 1}"
    labelAlign = "left"
    :colon= "false"
  >
    <a-row>
      <a-col :span="6">
        <a-form-item
          label="用户名称"
        >
          <a-input v-model="selectFormData.userName" placeholder="请输入用户名" />
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-form-item
          label="选择时间"
        >
          <a-range-picker v-model="selectFormData.dateTime" format = "YYYY-MM-DD" />
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-button style="margin-top:3px;margin-left:20px" type="primary" @click="handleFormLayoutChange">
          查询
        </a-button>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
export default {
  data() {
    return {
      selectFormData:{
        userName:undefined,
        dateTime:undefined
      }
    };
  },
  computed: {
   
  },
  methods: {
    handleFormLayoutChange() {
      this.$emit('selectHandle',this.selectFormData)
    },
  },
};
</script>

<style>
  .ant-advanced-search-form .ant-form-item {
    display: flex;
    align-items: center;
  }
  .ant-advanced-search-form .ant-form-item-control-wrapper {
    flex: 1;
  }
  .ant-advanced-search-form .ant-form-item {
    margin-bottom: 6px;
  }
</style>